import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const License: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 17.9813C7.425 17.9813 7.425 17.9813 7.35 17.9813C7.275 17.9813 0 16.2563 0 8.23125V3.73125C0 3.43125 0.15 3.13125 0.45 3.05625L7.2 0.05625C7.425 -0.01875 7.65 -0.01875 7.8 0.05625L14.55 3.05625C14.85 3.13125 15 3.43125 15 3.73125V8.23125C15 16.2563 7.725 17.9813 7.65 17.9813C7.575 17.9813 7.575 17.9813 7.5 17.9813ZM7.5 9.73125C5.325 9.73125 3.75 10.7063 3.75 11.9813C3.75 13.2563 5.325 14.2313 7.5 14.2313C9.675 14.2313 11.25 13.2563 11.25 11.9813C11.25 10.7063 9.675 9.73125 7.5 9.73125ZM7.5 3.73125C6.225 3.73125 5.25 4.70625 5.25 5.98125C5.25 7.25625 6.225 8.23125 7.5 8.23125C8.775 8.23125 9.75 7.25625 9.75 5.98125C9.75 4.70625 8.775 3.73125 7.5 3.73125Z"
        fill="currentColor"
      />
    </svg>
  )
})

License.displayName = 'License'
